module.exports = __webpack_public_path__ + "img/taylor-you.3ffd77b6.png";